import React from 'react';
import { Navigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { TabView, TabPanel } from 'primereact/tabview';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useAuth } from '../hooks/useAuth';
import { OrganizationsTab } from '../components/admin/OrganizationsTab';
import { UsersTab } from '../components/admin/UsersTab';

export const Admin: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-container">
        <ProgressSpinner />
      </div>
    );
  }

  if (!user?.is_superuser) {
    return <Navigate to="/" replace />;
  }

  return (
    <TabView>
      <TabPanel header="Organizations">
        <OrganizationsTab />
      </TabPanel>

      <TabPanel header="Users">
        <UsersTab />
      </TabPanel>
    </TabView>
  );
};

export default Admin;
